import * as Actions from '../actions/actions-consts';
import { Action } from '../../definitions/types';

export enum WebsiteCreationStatus {
  InProgress = 1,
  Ready,
  Failed,
}

export default function status(
  state: WebsiteCreationStatus = null,
  action: Action<any> // tslint:disable-line no-any
): WebsiteCreationStatus {
  switch (action.type) {
    case Actions.WEBSITE_CREATION_REQUESTED:
      return WebsiteCreationStatus.InProgress;
    case Actions.GENERAL_REQUEST_FAILED:
    case Actions.WEBSITE_CREATION_FAIL:
      return null;
    case Actions.WEBSITE_READY:
      return WebsiteCreationStatus.Ready;
    case Actions.LOGIN_LINK_FAILED:
    case Actions.WEBSITE_ID_FAILED:
      return WebsiteCreationStatus.Failed;
    default:
      return state;
  }
}
